import { render, staticRenderFns } from "./pointers.vue?vue&type=template&id=3c9dcdce&scoped=true&"
import script from "./pointers.vue?vue&type=script&lang=js&"
export * from "./pointers.vue?vue&type=script&lang=js&"
import style0 from "./pointers.vue?vue&type=style&index=0&id=3c9dcdce&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c9dcdce",
  null
  
)

export default component.exports